// extracted by mini-css-extract-plugin
export default {"table":"BookingsTable_table__1iAcP","disabled":"BookingsTable_disabled__-LXFI"};